module.exports = __webpack_public_path__ + "assets/Delta.1eb0480dac3f64daf944ebe60ed5cde1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Delta.png
// module id = 783
// module chunks = 0